const ChamomileIcon = (props) => {
    return (
        <svg
          width={80}
          height={80}
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <circle cx={21} cy={18} r={7} fill="#fff" />
          <circle cx={7} cy={50} r={7} fill="#fff" />
          <circle cx={32} cy={50} r={7} fill="#fff" />
          <circle cx={68} cy={50} r={7} fill="#fff" />
          <circle cx={50} cy={32} r={7} fill="#fff" />
          <circle cx={50} cy={68} r={7} fill="#fff" />
          <circle cx={21} cy={82} r={7} fill="#fff" />
          <circle cx={79} cy={82} r={7} fill="#fff" />
          <circle cx={50} cy={7} r={7} fill="#fff" />
          <circle cx={50} cy={93} r={7} fill="#fff" />
          <circle cx={79} cy={18} r={7} fill="#fff" />
          <circle cx={93} cy={50} r={7} fill="#fff" />
          <circle cx={50} cy={50} r={4} fill="#DFB342" />
        </svg>
      )
  }
  
  export default ChamomileIcon